// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vtcarticon-A0au9 {
  position: relative;
  width: 42px;
  padding-top: 5px;
  cursor: pointer;
}
.vtcarticon-A0au9 .cartImg-TmvFD {
  width: 30px;
}
.vtcarticon-A0au9 .numProducts-ipqfu {
  position: absolute;
  top: 0px;
  left: 26px;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: #333333;
  color: #FFFFFF;
  text-align: center;
  font-size: 12px;
  font-family: AvenirBlack;
}
.vtcarticon-A0au9 .price-OOo3j {
  margin-left: 16px;
  font-size: 16px;
  text-decoration: none;
}
.vtcarticon-A0au9 .price-OOo3j a:any-link {
  color: black;
  text-decoration: none;
}
.vtcarticon-A0au9 .price-OOo3j a {
  color: black;
  text-decoration: none;
}
.vtcarticon-A0au9 .price-OOo3j:any-link {
  color: black;
  text-decoration: none;
}
.vtcart-tWMK7:any-link {
  color: black;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/VTCartIcon/VTCartIcon.module.less"],"names":[],"mappings":"AAAA;EAAa,kBAAA;EAAmB,WAAA;EAAa,gBAAA;EAAkB,eAAA;AAK/D;AALA;EACW,WAAA;AAOX;AARA;EAEe,kBAAA;EAAmB,QAAA;EAAS,UAAA;EAAY,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,yBAAA;EAA2B,cAAA;EAAgB,kBAAA;EAAoB,eAAA;EAAiB,wBAAA;AAmBtL;AArBA;EAGS,iBAAA;EAAmB,eAAA;EAAiB,qBAAA;AAuB7C;AA1BA;EAIgB,YAAA;EAAa,qBAAA;AA0B7B;AA9BA;EAKM,YAAA;EAAa,qBAAA;AA6BnB;AAlCA;EAOmB,YAAA;EAAa,qBAAA;AA+BhC;AA7BA;EAAkB,YAAA;EAAa,qBAAA;AAiC/B","sourcesContent":[".vtcarticon {position:relative; width: 42px; padding-top: 5px; cursor: pointer;\n  .cartImg{width: 30px;}\n  .numProducts{position:absolute; top:0px; left: 26px; width: 16px; height: 16px; border-radius: 8px; background-color: #333333; color: #FFFFFF; text-align: center; font-size: 12px; font-family: AvenirBlack;}\n  .price{margin-left: 16px; font-size: 16px; text-decoration: none;\n    a:any-link {color:black; text-decoration: none;}\n    a{color:black; text-decoration: none;}\n  }\n  .price:any-link {color:black; text-decoration: none;}\n}\n.vtcart:any-link {color:black; text-decoration: none;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vtcarticon": `vtcarticon-A0au9`,
	"cartImg": `cartImg-TmvFD`,
	"numProducts": `numProducts-ipqfu`,
	"price": `price-OOo3j`,
	"vtcart": `vtcart-tWMK7`
};
export default ___CSS_LOADER_EXPORT___;
